import React from "react";
import { useFormikContext, useField } from "formik";
import useProductName from "brand-customization/useProductName";
import { Input } from "components/bootstrap";
import { FormikFormGroup, Select } from "components/common";
import { AZURE_AUTH_MODE } from "./types";
const AUTH_OPTIONS = [
  { value: AZURE_AUTH_MODE.AUTOMATIC, label: "Automatic" },
  { value: AZURE_AUTH_MODE.ACCOUNT_KEY, label: "Account key" }
];
export const validateAzureCredentialsFields = (credentials) => {
  var _a;
  const errors = {};
  if (!credentials) return errors;
  if (!credentials.auth_mode) {
    errors.auth_mode = "Required.";
  }
  if (!((_a = credentials.account_name) == null ? void 0 : _a.trim())) {
    errors.account_name = "Required.";
  }
  if (credentials.auth_mode === AZURE_AUTH_MODE.ACCOUNT_KEY && !credentials.account_key) {
    errors.account_key = "Required when using Account key authentication.";
  }
  return errors;
};
const AzureCredentialsFieldGroup = () => {
  var _a, _b;
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const productName = useProductName();
  const [, { error: authModeError, touched: authModeTouched }] = useField("credentials.auth_mode");
  const [, { error: accountKeyError, touched: accountKeyTouched }] = useField("credentials.account_key");
  const authMode = (_b = (_a = values.credentials) == null ? void 0 : _a.auth_mode) != null ? _b : AZURE_AUTH_MODE.AUTOMATIC;
  const handleAuthModeChange = (nextMode) => {
    if (nextMode === AZURE_AUTH_MODE.AUTOMATIC) {
      setFieldValue("credentials.account_key", void 0);
    }
    setFieldValue("credentials.auth_mode", nextMode);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "credentials.account_name",
      type: "text",
      label: "Account Name",
      placeholder: "your-account-name",
      help: "The name of your Azure storage account.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "credentials.endpoint_uri",
      type: "text",
      label: "Endpoint URL (optional)",
      help: "Only required if you want to override the default Azure Blob endpoint."
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "repository-credentials-auth-mode",
      label: "Authentication Type",
      bsStyle: authModeError && authModeTouched ? "error" : void 0,
      error: authModeTouched ? authModeError : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: `Choose how ${productName} authenticates to this container.`
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        inputId: "repository-credentials-auth-mode-select",
        placeholder: "Select Authentication Type",
        options: AUTH_OPTIONS,
        onChange: handleAuthModeChange,
        clearable: false,
        value: authMode
      }
    )
  ), authMode === AZURE_AUTH_MODE.ACCOUNT_KEY && /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "repository-credentials-account-key",
      type: "password",
      label: "Account Key",
      error: accountKeyTouched ? accountKeyError : void 0,
      bsStyle: accountKeyError && accountKeyTouched ? "error" : void 0,
      onChange: ({ target: { value } }) => setFieldValue("credentials.account_key", value === "" ? void 0 : { set_value: value }),
      onBlur: () => setFieldTouched("credentials.account_key", true),
      placeholder: "****************",
      help: "The access key of the storage account.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ));
};
export default AzureCredentialsFieldGroup;
